import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './workflow.paths';
import { workflowApp } from './workflow';
import { workflowJobErrorHandler, workflowJobExecutionHandler, workflowJobHandler, workflowRemoveJobHandler } from 'built-in-apps-shared/workflow';

export const WorkflowApp: SpherePlatformApp = {
    APP: workflowApp,
    PATHS,
    NOTIFICATION_EVENT_HANDLERS: [
        workflowJobHandler,
        workflowRemoveJobHandler,
        workflowJobErrorHandler,
        workflowJobErrorHandler,
        workflowJobExecutionHandler
    ]
};
